import { render, staticRenderFns } from "./ClanItem.vue?vue&type=template&id=2302125c&"
import script from "./ClanItem.vue?vue&type=script&lang=js&"
export * from "./ClanItem.vue?vue&type=script&lang=js&"
import style0 from "./ClanItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports